export default "__VITE_ASSET__BK3T1GD9__"